//Note that these plancodes match the ProdIDs from the interfaceSetup
export const ProdID = {
  TERM: '0180',
  TERM10: '0180',
  TERM20: '0180',
  TERM30: '0180',
  TERM100JOINT: '0562',
  TERM100: '0564',
  WHOLELIFE: '0903',
  WHOLELIFE20PAY: '0904',
  WHOLELIFEJOINT: '0905',
  WHOLELIFE20PAYJOINT: '0906',
  UL: '0602',
  CI: '0215',
  CIT20: '0216',
  CIT75: '0217',
  CI20PAYT75: '0218',
};

export const CoverageID = {
  TERM10: '181',
  TERM20: '182',
  TERM30: '183',
  ADB: '018',
  WP: '031',
  GPO: '061',
  AIB: '057',
  CPB: '021',
  ADB2: '019',
  WP2: '032',
  GPO2: '062',
  ROPD: '201',
  ROPS: '202',
  ROPE: '203',
};

export const DivOptions = {
  RAP: 'RAP',
  PUA: 'PUA',
  DOD: 'DOD',
  PIC: 'PIC',
  NONE: 'NONE',
};

export const PolicyTypes = {
  SINGLE: 'SINGLE',
  JOINTFIRST: 'JOINTFIRST',
  JOINTLAST: 'JOINTLAST',
};

export const PaymentOptions = {
  ANNUAL: '012',
  MONTHLY: '01',
  SEMIANNUAL: '06',
  QUARTERLY: '03',
};

export const RatingOptions = {
  STANDARD: '100',
  125: '125',
  150: '150',
  175: '175',
  200: '200',
};

export const interfaceItemsPolicyTypes = {
  TERM100: 'TERM100',
  LEVELTERM: 'LEVELTERM',
  WHOLELIFE: 'WHOLELIFE',
  UL: 'UL',
  CRITICALILLNESS: 'CRITICALILLNESS',
};


export const isCIPolicy = (prodId) => {
    return (
        prodId === ProdID.CI ||
        prodId === ProdID.CIT20 ||
        prodId === ProdID.CIT75 ||
        prodId === ProdID.CI20PAYT75
    );
};

//term 10, term 20 or term 30
export const isTermPolicy = (prodId) => {
  return (
    prodId === ProdID.TERM10 ||
    prodId === ProdID.TERM20 ||
    prodId === ProdID.TERM30 ||
    prodId === ProdID.TERM
  );
};

//term 100
export const isTerm100Policy = (prodId) => {
  return prodId === ProdID.TERM100;
};

//whole life policy
export const isWholeLifePolicy = (prodId) => {
  return prodId === ProdID.WHOLELIFE || prodId === ProdID.WHOLELIFE20PAY;
};

export const isWholeLifeProduct = (prodId) => {
    return prodId === ProdID.WHOLELIFE;
};

export const isWholeLife20PayProduct = (prodId) => {
    return prodId === ProdID.WHOLELIFE20PAY;
};

//universal life policy
export const isUniversalLifePolicy = (prodId) => {
  return prodId === ProdID.UL;
};
